// src/components/PagosListado.jsx
import { Link } from "react-router-dom";

export default function PagosListado({
  pagos,
  loading,
  error,
  busqueda,
  setBusqueda,
  currentPage,
  totalPages,
  onPrevPage,
  onNextPage,
  onNuevoPago,
}) {
  const filtrarPorBusqueda = (items) => {
    const term = busqueda.trim().toLowerCase();
    if (!term) return items;

    return items.filter((p) => {
      const paciente = `${p.paciente || ""} ${p.apellidos || ""}`.toLowerCase();
      const servicio = (p.service_name || "").toLowerCase();

      return paciente.includes(term) || servicio.includes(term);
    });
  };

  const pagosListadoFiltrados = filtrarPorBusqueda(pagos);

  return (
    <>
      <div className="pagos-actions">
        <input
          type="text"
          placeholder="Buscar por paciente o servicio..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />

        <button onClick={onNuevoPago}>➕ Registrar pago</button>
      </div>

      {loading ? (
        <p>Cargando pagos...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : pagos.length === 0 ? (
        <p>No hay pagos registrados.</p>
      ) : (
        <>
          <p className="pagination-info">
            Total resultados: <strong>{pagosListadoFiltrados.length}</strong> ·
            Página <strong>{currentPage}</strong> de{" "}
            <strong>{totalPages}</strong>
          </p>

          <table className="pv-table pagos">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Paciente</th>
                <th>Especialidad</th>
                <th>Servicio</th>
                <th>Importe (€)</th>
                <th>Método</th>
                <th>Estado</th>
                <th>Enviado</th>
                <th>Factura</th>
              </tr>
            </thead>
            <tbody>
              {pagosListadoFiltrados.map((p) => (
                <tr key={p.id}>
                  <td data-label="Fecha">
                    {new Date(p.date).toLocaleDateString("es-ES")}
                  </td>
                  <td
                    data-label="Paciente"
                    className="paciente-cell"
                    title={`${p.paciente} ${p.apellidos || ""}`}
                  >
                    <strong>{p.paciente}</strong> {p.apellidos}
                  </td>
                  <td data-label="Especialidad">
                    {p.specialty_name || p.specialty_code || "—"}
                  </td>
                  <td data-label="Servicio" className="service-cell">
                    {p.service_name || "-"}
                  </td>
                  <td
                    data-label="Importe (€)"
                    style={{ textAlign: "center" }}
                  >
                    {p.amount !== null && p.amount !== undefined
                      ? `${p.amount} €`
                      : "—"}
                  </td>
                  <td data-label="Método">
                    {p.payment_method === "efectivo"
                      ? "💵 Efectivo"
                      : "💳 Tarjeta"}
                  </td>
                  <td data-label="Estado">
                    <span
                      className={`status-pill ${
                        p.status === "pagado" ? "paid" : "pending"
                      }`}
                    >
                      {p.status === "pagado" ? "Pagado" : "Pendiente"}
                    </span>
                  </td>
                  <td data-label="Enviado">
                    <span
                      className={`status-pill ${
                        p.enviado ? "paid" : "pending"
                      }`}
                    >
                      {p.enviado ? "Enviado" : "Sin enviar"}
                    </span>
                  </td>
                  <td data-label="Factura" style={{ textAlign: "center" }}>
                    <Link
                      to={`/admin/factura/${p.id}`}
                      className="invoice-btn"
                      title="Ver factura"
                    >
                      🧾
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="pagination">
            <button onClick={onPrevPage} disabled={currentPage === 1}>
              ◀ Anterior
            </button>

            <span>
              Página {currentPage} de {totalPages}
            </span>

            <button onClick={onNextPage} disabled={currentPage === totalPages}>
              Siguiente ▶
            </button>
          </div>
        </>
      )}
    </>
  );
}
